import { Button } from './Button';
import { m } from '../paraglide/messages';

export interface ErrorStateProps {
  /** Customer-facing description of what failed to load. */
  message?: string;
  onRetry?: () => void;
  className?: string;
}

/** Inline failed-to-load state with a retry affordance - shown instead of
 *  faking an empty result when a fetch rejects. */
export const ErrorState = ({
  message = m.catalog_error_default(),
  onRetry,
  className = '',
}: ErrorStateProps) => (
  <div
    className={`flex flex-col items-center gap-3 rounded-xl border border-line bg-surface px-5 py-8 text-center ${className}`}
  >
    <p className="text-14 text-text-2">{message}</p>
    {onRetry ? (
      <Button variant="line" onClick={onRetry}>
        {m.catalog_retry()}
      </Button>
    ) : null}
  </div>
);
